module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yearSelect),
      expression: "yearSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.yearSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.yearList), function(year) {
    return _c('option', {
      domProps: {
        "value": year.value
      }
    }, [_vm._v("\n              " + _vm._s(year.label) + "\n            ")])
  }), 0)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(2)]) : (Object.keys(_vm.statementList).length > 0) ? _c('tbody', _vm._l((_vm.statementList), function(statement, key) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": statement,
        "target": "_blank"
      }
    }, [_vm._v("\n                  點擊下載\n                ")])])])
  }), 0) : (Object.keys(_vm.statementList).length === 0) ? _c('tbody', [_vm._m(3)]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary bt-explain",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#reportModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle mr-5"
  }), _vm._v("報表欄位說明\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "th-fit"
  }, [_vm._v("月份")]), _vm._v(" "), _c('th', [_vm._v("連結")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "reportModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-c",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header border-b-1"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("欄位說明")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-content-c"
  }, [_c('p', [_vm._v(" - 總會員數 : 曾訂購過的消費者人數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂購人數 : 本月訂購過的人數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數 : 狀態為已完成的(當月)訂單總數")]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數(平台) : 從你訂網頁進入訂購 "), _c('a', {
    attrs: {
      "href": "https://order.nidin.shop/"
    }
  }, [_vm._v("https://order.nidin.shop/")])]), _vm._v(" "), _c('p', [_vm._v(" - 總訂單數(專屬) : 從品牌專屬網頁進入訂購")]), _vm._v(" "), _c('p', [_vm._v(" - 總售出商品數 : 已完成狀態訂單下的所有售出商品數")]), _vm._v(" "), _c('p', [_vm._v(" - 總商品金額 : 已完成狀態訂單下的所有商品的金額加總")]), _vm._v(" "), _c('p', [_vm._v(" - 總銷售額 : 已完成狀態訂單下的實付總金額")]), _vm._v(" "), _c('p', [_vm._v(" - 總錯誤筆數 : 產生報表時尚未處理的筆數(未被更新為已完成、可對應例外訂單)")]), _vm._v(" "), _c('p', [_vm._v(" - 每日平均訂單數 : 總訂單數/月天數 ")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均商品數 : 總訂單商品數/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均商品金額 : 總商品金額/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")]), _vm._v(" "), _c('p', [_vm._v(" - 訂單平均銷售額 : 總銷售額/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28acc0ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Chart/Temp/ChartShare.vue
// module id = 2358
// module chunks = 1